<template lang="">
    <div>
        <iframe
            id="mmff"
            aria-label="1 Min Application A"
            frameborder="0"
            style="height: 1000px; width: 99%; border: none"
            :src="application_link"
        ></iframe>
    </div>
</template>
<script setup>
import { onMounted } from "vue";
const searchParams = new URLSearchParams(window.location.search);
const job_title = searchParams.get("jobTitle");
const application_link = searchParams.get("applicationLink");

onMounted(() => {
    document.onreadystatechange = () => {
        if (document.readyState == "complete") {
            // page load completed !

        }
    };
});

</script>
<style lang=""></style>
